import { Pct } from "@/components/layernav/primitives";
import { fmtBig } from "./SectorHero";

const Item = ({ label, value, delta, testid }: {
  label: string; value: string; delta?: number | null; testid: string;
}) => (
  <span data-testid={testid} className="inline-flex items-baseline gap-2 min-w-0">
    <span className="font-mono text-[9px] uppercase tracking-[0.16em] text-gray-500 whitespace-nowrap">{label}</span>
    <span className="font-mono text-[13px] font-bold text-white">{value}</span>
    {delta != null && <Pct v={delta} className="!text-[10.5px]" />}
  </span>
);

export const DeFiPulseStrip = ({ pulse }: { pulse: any }) => {
  if (!pulse || (pulse.tvl_usd == null && pulse.dex_volume_24h_usd == null && pulse.stablecoin_mcap_usd == null)) return null;
  const coreStale = (pulse.stale || []).some((k: string) =>
    ["tvl", "dex_volume", "stablecoins", "tvl_usd", "dex_volume_24h_usd", "stablecoin_mcap_usd"].includes(k));
  const live = pulse.updated_at && Date.now() - new Date(pulse.updated_at).getTime() < 15 * 60 * 1000 && !coreStale;
  return (
    <section className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-12" data-testid="defi-pulse-strip">
      <div className="rounded-xl border border-white/[0.08] bg-[#0b0c10] px-4 sm:px-5 py-3 flex flex-wrap items-center gap-x-7 gap-y-2">
        <span className="inline-flex items-center gap-2">
          <span className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-[#34D399]">DeFi Pulse</span>
          {live && <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-[#34D399] animate-pulse motion-reduce:animate-none" />}
        </span>
        <Item testid="strip-tvl" label="Total DeFi TVL" value={fmtBig(pulse.tvl_usd)} delta={pulse.tvl_change_24h_pct} />
        <Item testid="strip-dex" label="24H DEX Volume" value={fmtBig(pulse.dex_volume_24h_usd)} delta={pulse.dex_volume_change_24h_pct} />
        <Item testid="strip-stables" label="Stablecoin Supply" value={fmtBig(pulse.stablecoin_mcap_usd)} delta={pulse.stablecoin_change_24h_pct} />
        {pulse.articles_24h != null && (
          <Item testid="strip-stories" label="DeFi Stories · 24H" value={String(pulse.articles_24h)} />
        )}
        <span className="ml-auto font-mono text-[8.5px] uppercase tracking-wider text-gray-500">Data by DeFiLlama</span>
      </div>
    </section>
  );
};
